<template>
	<div class="select-option flex-column" :class="{'z-crt': selected}">
		<div class="flex-center">
			<h5 class="flex-grow">{{name}}</h5>
		</div>
		<p v-for="(item, i) in info" :key="i">{{item}}</p>
	</div>
</template>

<script>
	export default {
		name: 'selectOption',

		props: {
			name: String,
			info: Array,
			selected: Boolean
		}
	}
</script>

<style lang="stylus" scoped>
	.select-option  {
		gap: 6px;
		padding: 10px 8px;

		&:hover {
			background: #F5F5F5;
		}

		&.z-crt {
			color: var(--color-main);
			background: #eef2ff !important;

			div:after {
				content: '\e63f';
				font-family: 'iconfont';
			}
		}

		h5 {
			line-height: 20px;
			font-size: 13px;
			font-weight: normal;
		}

		p {
			line-height: 14px;
			color: #999;
			font-size: 12px;
		}
	}
</style>
